import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import useApp from "../../../store/contexts/AppContext";
import capitalizeEachFirstWord from "../../../utils/CapLetters";
import {
  LeftSideSingleChat,
  LeftSideSingleChatUsername,
  LeftSideSingleChatMessage,
  LeftSideSingleChatMessageMine,
} from "./styles";
import TruncateString from "../../../utils/TruncateString";
import { CHAT_ROOMS } from "../../../config/index";

const SectionTitle = styled(Box)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.1em",
  color: theme.palette.mode === "dark"
    ? alpha("#fff", 0.5)
    : alpha("#000", 0.5),
  padding: "16px 20px 10px",
  marginTop: "8px",
}));

const EmptyMessage = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  padding: "40px 20px",
  color: theme.palette.mode === "dark"
    ? alpha("#fff", 0.4)
    : alpha("#000", 0.45),
  fontSize: "0.9rem",
}));

export default function FilteredSearch({ styles, onClearSearch }) {
  const {
    appState: { userData, filteredChats, chats },
    switchActiveChat,
  } = useApp();
  const [filteredChatList, setFilteredChatList] = useState({
    success: true,
    direct_chats: {},
    group_chats: {},
    new_users: [],
  });

  useEffect(() => {
    // Update the messages state when filteredChats changes
    setFilteredChatList(filteredChats);
  }, [filteredChats]);

  const handleSelectNewUser = (user) => {
    // Create a temporary chat object for a new conversation
    const newChat = {
      id: null, // Will be created when first message is sent
      name: user.username,
      type: CHAT_ROOMS.TYPES.SINGLE,
      room_participants: [
        {
          id: userData.id,
          username: userData.username,
          is_admin: 1,
          is_online: userData.is_online,
          last_seen: userData.last_seen,
        },
        {
          id: user.id,
          username: user.username,
          is_admin: 0,
          is_online: user.is_online,
          last_seen: user.last_seen,
        },
      ],
      messages: [],
      pagination: {
        current_page: 1,
        next_page: null,
        page_size: 30,
        total_count: 0,
      },
      unread_count: 0,
      has_connected_before: false,
    };

    switchActiveChat(newChat);
  };

  const hasExistingChats = Object.keys(filteredChatList?.direct_chats || {}).length > 0;
  const hasNewUsers = (filteredChatList?.new_users || []).length > 0;
  const hasAnyResults = hasExistingChats || hasNewUsers;

  return (
    <>
      {hasExistingChats && (
        <>
          <SectionTitle>Conversations</SectionTitle>
          {/* This is the search filter result handler for single/direct chats */}
          {Object.keys(filteredChatList?.direct_chats).map((chatId) => {
            const currentChat = filteredChatList?.direct_chats[chatId];
            //Get the name of the other user when chat type is single
            const otherUserForDirectChat =
              currentChat?.type === CHAT_ROOMS.TYPES.SINGLE
                ? currentChat?.room_participants.find(
                  (participant) =>
                    participant.id?.toString() !== userData.id?.toString()
                )
                : null;

            const lastMessageOnChat =
              (currentChat?.messages || [])[(currentChat?.messages || []).length - 1];

            return (
              <LeftSideSingleChat
                key={chatId}
                onClick={() => {
                  const searchResult = filteredChatList?.direct_chats[chatId];
                  const fullChat = chats.find((c) => c.id?.toString() === chatId?.toString()) || searchResult;
                  switchActiveChat(fullChat);
                  onClearSearch?.();
                }}
              >
                <LeftSideSingleChatUsername>
                  {capitalizeEachFirstWord(otherUserForDirectChat?.username)}
                </LeftSideSingleChatUsername>

                <LeftSideSingleChatMessage>
                  {lastMessageOnChat?.sender_id?.toString() ===
                    userData?.id?.toString() && (
                      <LeftSideSingleChatMessageMine>
                        You:{" "}
                      </LeftSideSingleChatMessageMine>
                    )}
                  {lastMessageOnChat
                    ? TruncateString(lastMessageOnChat?.message)
                    : ""}
                </LeftSideSingleChatMessage>
              </LeftSideSingleChat>
            );
          })}
        </>
      )}

      {hasNewUsers && (
        <>
          <SectionTitle>New People</SectionTitle>
          {/* This is the search filter result handler for new users */}
          {filteredChatList?.new_users.map((user) => (
            <LeftSideSingleChat
              key={user.id}
              onClick={() => handleSelectNewUser(user)}
            >
              <LeftSideSingleChatUsername>
                {capitalizeEachFirstWord(user.username)}
              </LeftSideSingleChatUsername>

              <LeftSideSingleChatMessage>
                Start a new conversation
              </LeftSideSingleChatMessage>
            </LeftSideSingleChat>
          ))}
        </>
      )}

      {!hasAnyResults && (
        <EmptyMessage>
          No results found.
        </EmptyMessage>
      )}

      {
        // <>
        //   <br />
        //   <div className={styles.leftSideChatTitleBar}>Groups</div>
        //   {/* This is the search filter result handler for group chats */}
        //   {Object.keys(filteredChatList?.group_chats).length ? (
        //     Object.keys(filteredChatList?.group_chats).map((chatId) => {
        //       const currentChat = filteredChatList?.group_chats[chatId];
        //       //Get the name of the other user when chat type is single
        //       const otherUserForDirectChat =
        //         currentChat?.type === CHAT_ROOMS.TYPES.SINGLE
        //           ? currentChat?.room_participants.find(
        //               (participant) =>
        //                   participant.id?.toString() === userData.id?.toString()
        //             )
        //           : {username: currentChat.name};
        //       //Get last message sent on chat
        //       const lastMessageOnChat =
        //         currentChat.messages[currentChat.messages.length - 1];
        //       return (
        //         <LeftSideSingleChat
        //           key={chatId}
        //           onClick={() =>
        //             switchActiveChat(filteredChatList?.group_chats[chatId])
        //           }
        //         >
        //           <LeftSideSingleChatUsername>
        //             {capitalizeEachFirstWord(otherUserForDirectChat?.username)}
        //           </LeftSideSingleChatUsername>
        //           <LeftSideSingleChatMessage>
        //             {lastMessageOnChat?.sender_id?.toString() ===
        //               userData?.id?.toString() && (
        //               <LeftSideSingleChatMessageMine>
        //                 You:{" "}
        //               </LeftSideSingleChatMessageMine>
        //             )}
        //             {lastMessageOnChat
        //               ? TruncateString(lastMessageOnChat.message)
        //               : ""}
        //           </LeftSideSingleChatMessage>
        //         </LeftSideSingleChat>
        //       );
        //     })
        //   ) : (
        //     <Typography className={styles.emptyItem}>
        //       No Groups Available.
        //     </Typography>
        //   )}
        // </>
      }
    </>
  );
}
